import classNames from "classnames";

type NonPreviewableFileProps = {
  preview_url: string;
  name: string;
  fullWidth?: boolean;
  children?: React.ReactNode;
};

export const NonPreviewableFile = ({
  preview_url,
  name,
  fullWidth = false,
  children,
}: NonPreviewableFileProps) => {
  return (
    <div
      className={classNames(
        "t-flex t-items-center t-justify-center t-gap-1 t-rounded-lg t-p-7 t-bg-neutral-80 t-text-white t-h-14 t-self-center t-justify-self-center t-text-body-sm",
        {
          "t-w-2/5": !fullWidth,
          "t-w-full": fullWidth,
        }
      )}
    >
      {children ?? (
        <>
          File not previewable,{" "}
          <a
            href={preview_url}
            download
            className="t-text-blue-50 hover:t-text-blue"
          >
            click here
          </a>{" "}
          to download the file.
        </>
      )}
    </div>
  );
};
